function mmSlideProduct() {
    let thumbnailElems = document.querySelectorAll(".mm-thumbnail-elem");
    let splideElemMain = document.querySelector("#main-slider");
    let splideElemThumbnails = document.querySelector("#thumbnail-slider");
  
    if (window.abtest.id === "test-b") {
      thumbnailElems = document.querySelectorAll(".mm-thumbnail-elem-test-b");
      splideElemMain = document.querySelector("#main-slider-test-b");
      splideElemThumbnails = document.querySelector("#thumbnail-slider-test-b");
    }
  
    // SLIDER PRODUCT
    if (splideElemMain) {
      const main = new Splide(splideElemMain, {
        type: "slide",
        pagination: false,
        arrows: false,
        perPage: 1,
        breakpoints: {
          768: {
            pagination: true,
            gap: 10,
            padding: {
              right: 40,
            },
          },
        },
      });
  
      thumbnailElems.forEach(function (thumbnailElem) {
        thumbnailElem.addEventListener("click", function () {
          // GO SPLIDE
          main.go(parseInt(thumbnailElem.dataset.index));
  
          // ACTIVE THUMBNAIL
          thumbnailElems.forEach(function (thumbnailElem) {
            thumbnailElem.classList.remove("mm-active");
          });
          thumbnailElem.classList.add("mm-active");
        });
      });
  
      main.mount();
    }
  }

function mmSlideProductReassurance() {
    var splideElemMain = document.querySelector("#slider-reassurance");
    // SLIDER PRODUCT
    if (splideElemMain) {
        var main = new Splide(splideElemMain, {
            type: "slide",
            rewind: true,
            pagination: true,
            arrows: false,
            autoplay: true,
            interval: 5000,
            perPage: 1,
        });
        main.mount();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    mmSlideProduct();
    mmSlideProductReassurance();
});

// Ouverture des dropdowns
var allDropdown = document.querySelectorAll(".mm-product-form-dropdown");
allDropdown.forEach((content) => {
    content.addEventListener("click", function () {
        checkDropdown(content, false);
    });
    checkDropdown(content, true);
});
function checkDropdown(dropdown, load) {
    if (load && dropdown.classList.contains("active")) {
        const content = dropdown.nextElementSibling;
        content.style.height = content.scrollHeight + "px";
    } else if (!load) {
        dropdown.classList.toggle("active");
        const content = dropdown.nextElementSibling;
        if (content.style.height) {
            content.style.height = null;
        } else {
            content.style.height = content.scrollHeight + "px";
        }
        allDropdown.forEach((elem) => {
            if (elem != dropdown) {
                elem.classList.remove("active");
                elem.nextElementSibling.style.height = null;
            }
        });
    }
}

// STICKY CTA DISPLAY ONLY WHEN SCROLL AFTER TRUE CTA
var derniere_position_de_scroll_connue = 0;
var ticking = false;
var CTA = document.querySelector(".mm-main-product-button-container");
var CTA_position = CTA.offsetTop - window.screen.height / 3;

function showHideCta(position_scroll) {
    if (position_scroll > CTA_position) {
        CTA.classList.add("mm-cta-sticky");
    } else {
        CTA.classList.remove("mm-cta-sticky");
    }
}
if (window.innerWidth < 768) {
  // Faire quelque chose en mobile seulement
  window.addEventListener("scroll", function (e) {
      derniere_position_de_scroll_connue = window.scrollY;
      if (!ticking) {
          window.requestAnimationFrame(function () {
              showHideCta(derniere_position_de_scroll_connue);
              ticking = false;
          });
      }

      ticking = true;
  });
}

class VariantSelector extends HTMLElement {
    constructor() {
        super();
        this.cached = {};
        this.container = this.closest("#mm-main-product-container");
        this.addEventListener("change", this.onVariantChange);
    }

    onVariantChange() {
        this.getSelectedOptions();
        this.getSelectedVariant();

        if (this.currentVariant) {
            this.updateURL();
            this.variantFetch();
            this.selectMedia();
        }
    }

    getSelectedOptions() {
        this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
    }

    getVariantJSON() {
        this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    getSelectedVariant() {
        this.currentVariant = this.getVariantJSON().find((variant) => {
            const findings = !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);

            if (findings) return variant;
        });
    }

    updateURL() {
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    variantFetch() {
        var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

        if (this.cached[variantUrl]) {
            this.renderVariantInfo(this.cached[variantUrl]);
            return;
        }

        fetch(variantUrl)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                this.cached[variantUrl] = html;
                this.renderVariantInfo(html);
            })
            .catch((e) => {
                console.error(e);
            });
    }

    renderVariantInfo(html) {
        this.updateElementsOuter("#product_id", html);
        this.updateElementsOuter(".mm-main-product-tags-container", html);
        this.updateElementsOuter(".mm-product-form-component-format", html);
        this.updateElementsOuter(".mm-product-variant-picker-container", html);
        this.updateElementsOuter(".mm-main-product-button-container .mm-btn-primary", html);
        this.updateElementsOuter(".mm-reload", html);
    }


    selectMedia() {
        const first_media = document.querySelector(`.mm-thumbnail-elem[data-index="0"]`);
        // Utiliser une approche différente pour trouver le media correspondant à la variante actuelle
        let media_to_select = null;
        
        // Récupérer tous les thumbnails
        const all_thumbnails = document.querySelectorAll('.mm-thumbnail-elem');
        
        // Parcourir chaque thumbnail pour vérifier si l'ID de la variante actuelle est inclus
        for (const thumbnail of all_thumbnails) {
          const variant_ids = thumbnail.getAttribute('data-variant-id');
          
          // Si l'attribut data-variant-id contient l'ID de la variante actuelle
          if (variant_ids && variant_ids.split(' ').includes(this.currentVariant.id.toString())) {
            media_to_select = thumbnail;
            break;
          }
        }
        
        // S'il n'y a pas de correspondance exacte, essayons l'ancienne méthode
        if (!media_to_select) {
          media_to_select = document.querySelector(`.mm-thumbnail-elem[data-variant-id="${this.currentVariant.id}"]`);
        }

        const media_click_event = new Event("click");
        if (media_to_select) {
          media_to_select.dispatchEvent(media_click_event);
        } else {
          first_media.dispatchEvent(media_click_event);
        }
    }

    updateElement(selector, html) {
        const destination = this.container.querySelector(selector);
        const source = html.querySelector(selector);
        if (source && destination) destination.innerHTML = source.innerHTML;
    }

    updateElementsOuter(selector, html) {
      const destinations = this.container.querySelectorAll(selector);
      const sources = html.querySelectorAll(selector);

      destinations.forEach((destination, index) => {
          const source = sources[index];
          if (source) {
              destination.outerHTML = source.outerHTML;
          }
      });
    }
}
customElements.define("variant-selector", VariantSelector);

document.addEventListener("DOMContentLoaded", (event) => {
  const select_variant = new Event("change");
  document.querySelector('variant-selector').dispatchEvent(select_variant);
});

const DUREE_ELEM = document.querySelector('#mmDureeInfo > span');

function mmChangeDuree(duree) {
  DUREE_ELEM.innerText = duree;
}

function mmSetupDuree() {
  const duree = document.querySelector(".mm-product-variant-checkbox:checked");
  if (duree) {
  const dureeData = duree.dataset.duree;
    DUREE_ELEM.innerText = dureeData;
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  mmSetupDuree();
});

// Klarna
document.addEventListener("DOMContentLoaded", () => {
  console.log("La page est chargée");
  
  // Sélectionner l'élément où afficher le message
  const messageContainer = document.getElementById("message-container");
  
  document.querySelectorAll('input[type="radio"][name="purchase_option"]').forEach((radioButton) => {
    radioButton.addEventListener("change", function() {
      console.log("Changement détecté sur le radio:", this.value);
      
      // Si "one_time" est sélectionné, afficher "coucou" dans le message-container
      if (radioButton && radioButton.checked) {
        const klarnaContainer = document.getElementById("klarna-widget-container");
      
        if (radioButton.value === "one_time") {
          console.log("coucou");
          klarnaContainer.style.display = "block"; // Affiche le widget Klarna
        } else {
          console.log("Autre option sélectionnée");
          klarnaContainer.style.display = "none"; // Masque le widget Klarna
        }
      }
    });
  });
});